<template>
  <div class="image-choice-vote" ref="imageChoiceContainer">
    <div v-for="(item,index) in items" :key="item.id" class="choice-vote-item">
      <div class="vote-rank-box">
        <img v-if="item.num<4" :src="'/assets/img/vote/'+item.num +'.png'" width="20" />
        <template v-else>
          <span>{{ item.num}}</span>
        </template>
      </div>
      <div>
        <div v-for="img in item.content.image" :key="img.url">
          <img :src="img.url" width="44" />
        </div>
      </div>
      <div class="image-vote-content">
        <div class="choice-vote-title">
          <div>
            <div v-html="item.content.richText"></div>
          </div>
          <div class="vote-num-box">
            <span class="vote-num">{{ item.voteNum }}</span>
            <span>票</span>
          </div>
        </div>
        <div>
          <custom-progress :percentage="item.percentage" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { questionType } from 'dygc'
import choice from '@/vote/choice'
import CustomProgress from './CustomProgress.vue'
import { previewImage } from '../assets/js/preview-image'

export default {
  name: 'ImageChoiceVote',
  components: { CustomProgress },
  mixins: [choice],
  type: [questionType.IMAGE_CHOICE, questionType.IMAGE_MULTIPLE_CHOICE],
  mounted() {
    previewImage(this.$refs.imageChoiceContainer)
  }
}
</script>

<style scoped lang="scss">
.image-choice-vote {
  .choice-vote-item {
    margin-bottom: 18px;
    display: flex;
    gap: 8px;

    &:last-child {
      margin-bottom: 0;
    }

  }

  .image-vote-content {
    flex: 1;
  }

  .choice-vote-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }
}
</style>